import { expand } from 'uri-template-lite';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { InputDataUrl } from './InputDataUrl';
import { InputDataCopy } from '../schema/types';
import { InputUpdateResponseSchema } from '../schema/InputDataDetailsSchema';

const postInputDataDetailsAction = async (
  request: InputDataCopy,
  headers?: HttpHeaders
) => {
  const { copy, type, ...body } = request;
  const response = await apiClient.post(
    expand(InputDataUrl.INPUT_DATA_SUBJECT_ACTION, {
      action: copy ? 'copy' : 'impute',
      type,
    }),
    body,
    headers ? { headers } : undefined
  );
  return InputUpdateResponseSchema.parse(response.data);
};

export const useInputDataDetailsActionMutation = createApiMutationHook(
  ['inputDataDetailsActionMutation'],
  getMutationFn(postInputDataDetailsAction)
);
